import createRoute              from '@widesk-ui/tools/createRoute';
import DeliverableTransferModel from '@models/shop/DeliverableTransferModel';

export default createRoute.splitView('/entertainments/:entertainmentId/deliverable_transfers', 'shop', 'DeliverableTransferSplitView', DeliverableTransferModel.localize('plural'));
